import { Button, Col, Typography } from "antd";
import { Dispatch, SetStateAction } from "react";
import { useCampaignsProducts } from "../../../../modules/campaigns";
import { WrapperModalCampaigns } from "../../../../modules/campaigns/ui/styled";
import { SimpleInputSelect } from "../inputs";

const { Title } = Typography;

interface Props {
  modalIsOpen: boolean;
  setModalIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const ModalCampaignsProducts = ({
  modalIsOpen,
  setModalIsOpen,
}: Props) => {
  const {
    arrOptionsProducts,
    changeSelectValue,
    onSubmitCreateProductForCampaign,
    onInputKeyDown,
    selectedValue,
    isLoading,
  } = useCampaignsProducts();

  return (
    <WrapperModalCampaigns
      title={`Agregar un nuevo producto a la campaña`}
      open={modalIsOpen}
      width={"320px"}
      destroyOnClose
      onClose={() => setModalIsOpen(false)}
    >
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Producto:
        </Title>
        <Typography.Text
          type="secondary"
          style={{ fontSize: 12, marginBottom: 8 }}
        >
          Si ya está en la campaña, aparece deshabilitado y no se puede volver a
          subir.
        </Typography.Text>
        <SimpleInputSelect
          showSearch
          valueSelect={selectedValue}
          onChange={changeSelectValue}
          label={"Seleccione producto"}
          onInputKeyDown={onInputKeyDown}
          dataOptions={arrOptionsProducts || []}
          maxWidth="100%"
        />
      </Col>

      <Button
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
        onClick={() => {
          void onSubmitCreateProductForCampaign().then((ok) => {
            if (ok) setModalIsOpen(false);
          });
        }}
        loading={isLoading}
      >
        Agregar producto a la campaña
      </Button>
    </WrapperModalCampaigns>
  );
};
